@if (city()) {
	<div
		[ngClass]="{
			'border-danger text-danger': isCityWithSell() && !allPeopleIsTaken(),
			'border-success text-success': allPeopleIsTaken() && isCityWithSell(),
		}"
		[matMenuTriggerFor]="transportKind() === OfferTransportKind.PLANE ? null : menu"
		(click)="transportKind() === OfferTransportKind.PLANE && !!vehicleInUse() ? takeAll() : null"
		class="h-100 d-flex flex-column gap-1 align-items-center justify-content-center btn btn-outline-secondary"
	>
		@for (item of vehiclesWhoseTakenSlots(); track $index) {
			{{ item + ($last ? '' : ', ') }}
		}
		<span class="fw-bold">{{ city().location.name }}</span>
		<span>
			{{ totalAlreadyTakenSlots() }} ({{ sumOfPeople().confirm }} / {{ sumOfPeople().option }}) +
			{{ city().antennaParticipants }}</span
		>
	</div>
} @else {
	<div class="h-100"></div>
}

<mat-menu #menu>
	<button mat-menu-item class="text-small" [disabled]="!vehicleInUse()" (click)="passThrough()">
		Przejazd przez
	</button>
	<button mat-menu-item class="text-small" [disabled]="!vehicleInUse()" (click)="takeAll()">
		Zabierz wszystkich
	</button>
	<button mat-menu-item class="text-small" [disabled]="!vehicleInUse()" (click)="leftAll()">Zostaw wszystkich</button>
	<button mat-menu-item class="text-small" (click)="openCityModal()">Zaawansowane</button>
</mat-menu>
